import { Component, input } from '@angular/core';
import { FormFieldHint } from '../../form-field.interface';
import { FormFieldHintDetailsComponent } from '../form-field-hint-details/form-field-hint-details.component';

@Component({
  selector: 'ui-form-field-hint',
  templateUrl: './form-field-hint.component.html',
  styleUrls: ['./form-field-hint.component.scss'],
  standalone: true,
  imports: [FormFieldHintDetailsComponent],
})
export class FormFieldHintComponent {
  readonly hint = input<FormFieldHint>();
  readonly hintInfo = input<string>();
  readonly rightHint = input<FormFieldHint>();
  readonly rightHintInfo = input<string>();
}
